module.exports = "<div class=\"wrapper wrapper-content animated fadeInUp\"> <div class=ibox> <breadcrumb></breadcrumb> <iframe-template path-url={{url}} css=100% key=invoiceAnalysis></iframe-template> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/statistics/chartAnalysis/invoiceAnalysis/view/invoiceAnalysis.html
// module id = o1/T
// module chunks = 0